import React from 'react';
import { motion } from 'framer-motion';
import bg from '@/assets/homepage/bg2.png';

const stats = [
  { value: '5+', label: 'Years of experience' },
  { value: '30+', label: 'Projects completed' },
  { value: '2', label: 'Avg. weeks to deliver' }
];

const AboutSection: React.FC = () => (
  <section
    className='relative w-full bg-white z-10 bg-cover bg-center py-24 max-[560px]:py-8'
    style={{ backgroundImage: `url(${bg}` }}
  >
    <div className='w-full mx-auto px-4 max-w-[1279px]'>
      <div className='w-full grid grid-cols-4 max-[768px]:grid-cols-2  max-[560px]:grid-cols-1 max-[560px]:gap-5'>
        <motion.h2
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className='text-4xl font-semibold mb-8 text-[#FFFFFF]'
        >
          About us
        </motion.h2>
        {stats.map((stat, i) => (
          <motion.div
            key={stat.value}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 * i }}
            viewport={{ once: true }}
            className='flex-1 text-center'
          >
            <div className='text-5xl font-bold mb-2 text-[#FFFFFF] max-[768px]:text-4xl'>{stat.value}</div>
            <div className='text-lg text-[#FFFFFF]'>{stat.label}</div>
          </motion.div>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
        className='text-[28px] text-[#FFFFFF] w-full mt-[59px] max-[560px]:text-base max-[560px]:text-center'
      >
        We’re a multidisciplinary agency that blends technology, creativity, and strategy to fuel your growth. From
        startups to established enterprises, we partner with brands that are ready to level up. Our team of developers,
        designers, and marketers work seamlessly to deliver solutions that are not only effective, but built to last.
      </motion.p>
    </div>
  </section>
);

export default AboutSection;
